import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Autumn/PlaceValueWithin10/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'PlaceValueWithin10',
  field: 'Number',
  weeks: [1, 5],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/1SortObjects" */ './1SortObjects'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/2CountObjects" */ './2CountObjects'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/3CountObjectsFromALargerGroup" */ './3CountObjectsFromALargerGroup'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/4RepresentObjects" */ './4RepresentObjects'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/5RecogniseNumbersAsWords" */ './5RecogniseNumbersAsWords'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/6CountOnFromAnyNumber" */ './6CountOnFromAnyNumber'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/7OneMore" */ './7OneMore')
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/8CountBackwardsWithin10" */ './8CountBackwardsWithin10'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(/* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/9OneLess" */ './9OneLess')
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/10CompareGroupsByMatching" */ './10CompareGroupsByMatching'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/11FewerMoreSame" */ './11FewerMoreSame'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/12LessThanGreaterThanEqualTo" */ './12LessThanGreaterThanEqualTo'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/13CompareNumbers" */ './13CompareNumbers'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/14OrderObjectsAndNumbers" */ './14OrderObjectsAndNumbers'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/PlaceValueWithin10/15TheNumberLine" */ './15TheNumberLine'
        )
    })
  ]
});
export default Block;
